module.exports = __webpack_public_path__ + "static/media/rainy.1cb273e9.svg";